module.exports = __webpack_public_path__ + "img/kp.32070bf9.svg";